import {ApplicationObjectBase} from '../database-models/application-object-base';
import {ApplicationObjectTypeBase} from '../database-models/application-object-type-base';
//Generated Imports
export class ApplicationObject extends ApplicationObjectBase 
{




//#region Generated Reference Properties
//#region applicationObjectType Prop
applicationObjectType : ApplicationObjectTypeBase;
//#endregion applicationObjectType Prop

//#endregion Generated Reference Properties



























}